@if (browserSession) {
  <div class="wm-m-browsersessionviewer-wrapper">
    <div class="wm-m-browsersessionviewer-info">
      <div class="browsersession-starttime info-item">
        <div class="wm-textwithtoplabel">
          <div class="toplabel">Start Time</div>
          <div class="text">{{ browserSession?.optStart | date:'short' }}</div>
        </div>
      </div>
      <div class="browsersession-duration info-item">
        <div class="wm-textwithtoplabel">
          <div class="toplabel">Duration</div>
          <div class="text">{{ duration }}</div>
        </div>
      </div>
      <div class="browsersession-state info-item">
        <div class="wm-textwithtoplabel">
          <div class="toplabel">State</div>
          <div class="text">{{ browserSession.sessionState }}</div>
        </div>
      </div>
      <div class="browsersession-browser info-item">
        <div class="wm-textwithtoplabel">
          <div class="toplabel">Browser</div>
          <div class="text">
            <wm-browser [browser]="browserSession.browser"></wm-browser>
          </div>
        </div>
      </div>
    </div>
    <div class="wm-m-browsersessionviewer-body">
      <div class="browsersession-timeline">
        @if (stateArtifacts) {
          <div class="browsersession-timeline-state timeline-top">
            <div class="browsersession-state-timearea"></div>
          </div>
        }
        @if (artifactsWithoutState) {
          <div class="browsersession-timeline-state">
            <div class="browsersession-state-timearea"></div>
            @if (artifactsWithoutState.length > 0) {
              <div class="browsersession-state-content">
                <div class="state-label-with-line">
                  <span class="state-label">No State</span>
                  <span class="state-label-line"></span>
                </div>
                <div class="state-artifacts">
                  @for (artifactId of artifactsWithoutState; track artifactId) {
                    <div class="state-artifact artifact-wrapper artifact-span-border-wrapper">
                      <wm-artifact [browserSessionId]="browserSession.id" [artifactId]="artifactId" [associatedState]="undefined" [referenceTime]="browserSession.optStart" [summary]="true"></wm-artifact>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="wm-spinner-centered">
            <p-progressSpinner></p-progressSpinner>
            <div class="wm-spinnerlabel">Loading artifacts...</div>
          </div>
        }
        @for (state of stateArtifacts; track state) {
          @if (state) {
            <div class="browsersession-timeline-state">
              <div class="browsersession-state-timearea"></div>
              <div class="browsersession-state-content">
                <div class="state-label-with-line">
                  <span class="state-label">State</span>
                  <span class="state-label-line"></span>
                </div>
                <div class="state-time">{{ timeFromStart(state.creationTime) }}</div>
                <div class="state-name">{{ state.name }}</div>
                <div class="state-artifacts">
                  @for (artifactId of (stateToArtifacts.get(state.id) || []); track artifactId) {
                    <div class="state-artifact artifact-wrapper artifact-span-border-wrapper">
                      <wm-artifact [browserSessionId]="browserSession.id" [artifactId]="artifactId" [associatedState]="artifactsToState.get(artifactId)" [referenceTime]="browserSession.optStart" [summary]="true"></wm-artifact>
                    </div>
                  }
                </div>
              </div>
            </div>
          } @else {
            <div class="wm-spinner-centered">
              <p-progressSpinner></p-progressSpinner>
              <div class="wm-spinnerlabel">Loading BrowserSession...</div>
            </div>
          }
        }
        @if (!stateArtifacts) {
          <div class="wm-spinner-centered">
            <p-progressSpinner></p-progressSpinner>
            <div class="wm-spinnerlabel">Loading states...</div>
          </div>
        }
        @if (stateArtifacts) {
          <div class="browsersession-timeline-state timeline-bottom">
            <div class="browsersession-state-timearea"></div>
          </div>
        }
        @if (loadingNewArtifacts) {
          <div class="wm-spinner-centered">
            <p-progressSpinner></p-progressSpinner>
            <div class="wm-spinnerlabel">Loading new artifacts...</div>
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="wm-spinner-centered">
    <p-progressSpinner></p-progressSpinner>
    <div class="wm-spinnerlabel">Loading BrowserSession...</div>
  </div>
}

